import { ChangeDetectionStrategy, Component } from '@angular/core';

/**
 * Centered activity spinner (splash) used while the app is loading or while a
 * navigation/redirect is pending. Presentational only; the caller decides when
 * to show it. Shares the same markup that lives in index.html before bootstrap.
 */
@Component({
  selector: 'loading-indicator',
  standalone: true,
  imports: [],
  templateUrl: './loading-indicator.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadingIndicatorComponent {}
